import { Navigate, useParams } from "react-router-dom";

import { URL_MAP_VIEW } from "src/router/routes";

export const HandleRedirection = () => {
    const { schema } = useParams<{ schema: string }>();

    return <Navigate to={`/${schema}${URL_MAP_VIEW}`} replace />;
};
